import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import CoreNotification from './Notification';
var propTypes = {
  /**
   * @ignore - Prop that passes new Notification component
   */
  renderNotification: PropTypes.func
};

var NotificationItem = /*#__PURE__*/function (_Component) {
  _inherits(NotificationItem, _Component);

  var _super = _createSuper(NotificationItem);

  function NotificationItem(props) {
    var _this;

    _classCallCheck(this, NotificationItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function (nextProps, nextState) {
      return _this.props !== nextProps;
    });

    _this.state = {};
    return _this;
  }

  _createClass(NotificationItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          renderNotification = _this$props.renderNotification;
      var Notification = renderNotification ? renderNotification : CoreNotification;
      return /*#__PURE__*/React.createElement(Notification, _extends({}, this.props, {
        disableAnimation: index !== 0
      }));
    }
  }]);

  return NotificationItem;
}(Component);

NotificationItem.propTypes = propTypes;
export default NotificationItem;